"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VEHICLE_FIELDS = void 0;
var entities_1 = require("@common/entities");
exports.VEHICLE_FIELDS = [
    __assign(__assign({}, entities_1.VehicleFields.make), { type: entities_1.FieldType.Text, sequence: 1, customType: entities_1.FieldType.Text, required: true, enabled: true }),
    __assign(__assign({}, entities_1.VehicleFields.model), { type: entities_1.FieldType.Text, sequence: 2, customType: entities_1.FieldType.Text, required: true, enabled: true }),
    __assign(__assign({}, entities_1.VehicleFields.color), { type: entities_1.FieldType.Text, sequence: 3, customType: entities_1.FieldType.Text, required: true, enabled: true }),
    __assign(__assign({}, entities_1.VehicleFields.year), { type: entities_1.FieldType.Number, sequence: 4, customType: entities_1.FieldType.Number, required: true, enabled: true }),
    __assign(__assign({}, entities_1.VehicleFields.licensePlateNumber), { type: entities_1.FieldType.Text, sequence: 5, customType: entities_1.FieldType.Text, required: true, enabled: true }),
    __assign(__assign({}, entities_1.VehicleFields.countryCode), { customType: entities_1.FieldType.CountryDropdown, enabled: true, options: [], required: true, sequence: 6, type: entities_1.FieldType.CountryDropdown }),
    __assign(__assign({}, entities_1.VehicleFields.stateCode), { type: entities_1.FieldType.StateDropdown, sequence: 7, customType: entities_1.FieldType.StateDropdown, required: true, enabled: true }),
];
